import { Tooltip, Tag as ChakraTag } from "@chakra-ui/react"
import { Icon } from "components"

export default function Tag({ label, icon, children, ...props }){
    return(
    <Tooltip label={label}>
        <ChakraTag {...props}>{ icon ? <Icon name={icon} /> : children }</ChakraTag>
    </Tooltip>
    )
}